import React from "react";
import "./loader.styles.css";

export const Loader = () => {
    return (
        <div className="loader">
            <h1 className="loader-brand">RealCoinz</h1>
        </div>
    );
}